const e = {
  // StyleOverrides are on the title/typograpy are to support putting
  // a close button nested inside the header that is inline with the title
  styleOverrides: {
    root: {
      justifyContent: "space-between",
      alignItems: "center",
      display: "flex"
    }
  }
};
export {
  e as default
};
